import React, { useEffect, useState } from "react";
import "dayjs/locale/de";
import dayjs from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker as MuiDatePicker } from "@mui/x-date-pickers/DatePicker";
import { CalendarTodayOutlined } from "@mui/icons-material";
import PropTypes from "prop-types";
import { textFieldDefaults } from "../formControlDefaults.js";

DatePicker.propTypes = {
  item: PropTypes.object.isRequired,
  value: PropTypes.any,
  error: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  showErrorText: PropTypes.bool,
  disabled: PropTypes.bool,
};

export default function DatePicker(props) {
  const {
    item,
    value,
    onChange,
    error = null,
    showErrorText = true,
    disabled = false,
  } = props;
  const [localValue, setLocalValue] = useState(null);

  useEffect(() => {
    setLocalValue(dayjs(value));
  }, [value]);

  const convertToDefEventPara = (name, value) => {
    setLocalValue(value);
    if (value?.isValid())
      onChange({
        target: {
          name,
          value,
        },
      });
  };

  let helperText = "";
  helperText = error;
  let boolError = false;
  if (error) boolError = true;

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="de">
      <MuiDatePicker
        fullWidth
        label={item.label}
        name={item.name}
        value={localValue}
        onChange={(date) => convertToDefEventPara(item.name, date)}
        disabled={disabled}
        slots={{ openPickerIcon: CalendarTodayOutlined }}
        slotProps={{
          textField: {
            ...textFieldDefaults,
            helperText: helperText,
            error: boolError,
          },
        }}
      />
    </LocalizationProvider>
  );
}
